export default {
  root: ({ props, instance }) => ({
    class: [
      // Display and Position
      'inline-flex items-center text-xs',
      'relative',
      // Shape
      {
        'rounded-lg h-12':
          !instance.$attrs['search'] && !instance.$attrs['boq-input'] && !instance.$attrs['msisdn'],
      },
      { 'rounded !h-9 4xl:h-11': instance.$attrs['boq-input'] },
      { 'h-8 rounded-lg': instance.$attrs['search'] },
      {
        'h-12':
          !instance.$attrs['search'] && !instance.$attrs['boq-input'] && instance.$attrs['msisdn'],
      },

      // Color and Background
      'bg-transparent',
      { 'border-0': !props.invalid && instance.$attrs['borderless'] && !props.disabled },
      // Disabled
      { 'bg-gray-100!': props.disabled && !instance.$attrs['borderless'] && props.size },
      {
        'bg-blue-50! border-blue-800':
          instance.$attrs['has-value'] && !instance.$attrs['search'] && props.size,
      },
      {
        'bg-blue-50!': instance.$attrs['focused'] && props.size && !props.disabled,
      },
      {
        'bg-white hover:bg-brand-greyscale-neutral-50 border border-gray-200':
          instance.$attrs['search'] && !instance.$attrs['focused'],
      },
      {
        'border-transparent': instance.$attrs['msisdn'],
      },
      {
        'bg-blue-50! border border-blue-600! text-blue-600!':
          (instance.$attrs['focused'] || instance.$attrs['has-value']) &&
          instance.$attrs['search'] &&
          !instance.$attrs['boq-input'],
      },
      {
        'border-blue-400!':
          instance.$attrs['focused'] &&
          !instance.$attrs['search'] &&
          !instance.$attrs['borderless'] &&
          !props.disabled &&
          props.size === null,
      },
      {
        'border-blue-800!':
          instance.$attrs['focused'] &&
          !instance.$attrs['search'] &&
          !instance.$attrs['borderless'] &&
          !props.disabled &&
          props.size,
      },
      {
        'border-2':
          !instance.$attrs['borderless'] && !instance.$attrs['search'] && props.size === null,
      },
      {
        border: !instance.$attrs['borderless'] && !instance.$attrs['search'] && props.size,
      },
      {
        'border-black': instance.$attrs['has-value'] && !props.disabled,
      },
      {
        'border-2! border-black! border-r-0!':
          instance.$attrs['has-value'] &&
          instance.$attrs['msisdn'] &&
          !props.disabled &&
          !instance.$attrs['focused'],
      },
      {
        'border-border-border-300': !instance.$attrs['has-value'] && !instance.$attrs['boq-input'],
      },
      {
        'border-border-border-300':
          (instance.$attrs['boq-input'] && instance.$attrs['has-value']) ||
          (instance.$attrs['boq-input'] && !instance.$attrs['has-value']),
      },

      // Invalid State
      { 'border-red-500': props.invalid },

      // Transitions
      'transition-colors duration-200',

      // Misc
      {
        'bg-brand-greyscale-neutral-400! border-0 cursor-not-allowed':
          props.disabled && !instance.$attrs['borderless'] && instance.$attrs['search'],
      },
      {
        'border-border-border-300 opacity-60 select-none cursor-not-allowed text-txt-800!':
          ((props.disabled && instance.$attrs['has-value']) ||
            (props.disabled && !instance.$attrs['has-value'])) &&
          !instance.$attrs['search'],
      },
      {
        'opacity-40! select-none! cursor-not-allowed!':
          ((props.disabled && !instance.$attrs['has-value']) ||
            (props.disabled && instance.$attrs['has-value'])) &&
          instance.$attrs['universal-item-search'] &&
          !instance.$attrs['search'],
      },

      // Height
      { '!h-8': props.size === 'small' },
      { 'h-12': props.size === null },
    ],
  }),
  label: ({ props, instance }) => ({
    class: [
      //Font
      { 'mt-1': !instance.$attrs['boq-input'] && !instance.$attrs['has-value'] },
      {
        'text-txt-700 text-xs':
          (!instance.$attrs['focused'] && instance.$attrs['search']) ||
          (instance.$attrs['borderless'] && !instance.$attrs['has-value']),
      },
      {
        'text-blue-800! font-medium':
          instance.$attrs['has-value'] && !instance.$attrs['search'] && props.size,
      },
      { 'text-txt-800': instance.$attrs['has-value'] && !instance.$attrs['search'] },
      {
        'text-blue-800! font-medium':
          instance.$attrs['has-value'] &&
          instance.$attrs['search'] &&
          !instance.$attrs['boq-input'],
      },
      {
        'text-txt-600 text-xs': !instance.$attrs['has-value'] && !instance.$attrs['search'],
      },
      { '!xl:text-sm': instance.$attrs['has-value'] && !instance.$attrs['boq-input'] },

      // Display
      'block',
      'flex-auto',

      // Color and Background
      'bg-transparent',
      'border-0',
      {
        'text-surface-800': props.modelValue != undefined,
        'text-surface-400': props.modelValue == undefined,
      },
      'placeholder:text-surface-400 placeholder:text-xs xl:placeholder:text-sm',
      { 'text-gray-500!': props.disabled && props.size },

      // Sizing and Spacing
      'w-[1%]',
      'p-3',
      { 'pr-7': props.showClear },
      {
        'pt-5':
          instance.$attrs['has-value'] &&
          instance.$attrs['show-label'] &&
          !instance.$attrs['boq-input'],
      },
      {
        'pt-2 text-xs': instance.$attrs['has-avatar'],
      },
      {
        'pt-6 text-sm':
          instance.$attrs['has-value'] &&
          instance.$attrs['show-label'] &&
          instance.$attrs['universal-item-search'],
      },
      {
        'pt-6 text-sm':
          instance.$attrs['has-value'] &&
          instance.$attrs['show-label'] &&
          instance.$attrs['universal-item-search'],
      },
      {
        'pb-2':
          instance.$attrs['has-value'] &&
          !instance.$attrs['show-label'] &&
          !instance.$attrs['boq-input'] &&
          !instance.$attrs['msisdn'],
      },
      {
        'pt-2':
          !instance.$attrs['has-value'] &&
          !instance.$attrs['boq-input'] &&
          !instance.$attrs['msisdn'],
      },
      { 'pl-2 pr-0': instance.$attrs['msisdn'] },

      //Shape
      'rounded',

      // Transitions
      'transition',
      'duration-200',

      // States
      'focus:outline-none focus:shadow-none focus:shadow-md',

      // Misc
      'relative',
      'cursor-pointer',
      { 'max-w-[350px] truncate': instance.$attrs['search-filter'] },

      {
        'text-white! cursor-not-allowed!':
          props.disabled && !instance.$attrs['borderless'] && instance.$attrs['search'],
      },
      {
        'text-txt-800! cursor-not-allowed!':
          ((props.disabled && instance.$attrs['has-value']) ||
            (props.disabled && !instance.$attrs['has-value'])) &&
          !instance.$attrs['search'],
      },
    ],
  }),
  dropdown: ({ instance }) => ({
    class: [
      // Flexbox
      'flex items-center justify-center',
      'shrink-0',

      // Color and Background
      'bg-transparent',
      { 'text-blue-800': !instance.$attrs['msisdn'] },

      // Size
      { 'w-10': !instance.$attrs['msisdn'] },
      { 'w-6': instance.$attrs['msisdn'] },

      // Shape
      'rounded-r-lg',
    ],
  }),
  overlay: ({ instance }) => ({
    class: [
      // Colors
      'bg-white',
      'text-surface-700 py-2',

      // Shape
      'border',
      { 'border-blue-800': !instance.$attrs['msisdn'] },
      { 'border-border-border-300': instance.$attrs['msisdn'] },
      'rounded-lg',
      'shadow-lg',

      // Size
      'max-w-60',
    ],
    'data-testId': 'select-overlay',
  }),
  listContainer: {
    class: [
      // Sizing
      'max-h-[200px]',

      // Misc
      'overflow-auto',
    ],
    'data-testId': 'select-container',
  },
  list: ({ props }) => ({
    class: ['list-none m-0 ', { 'pt-8': props.filter }],
    'data-testId': 'select-list',
  }),
  filterIcon: {
    class: 'text-gray-400 absolute right-3 min-w-3 min-h-3 z-10',
  },
  option: ({ context, instance, props }) => ({
    class: [
      'relative',
      'flex items-center',
      { 'max-w-[430px] text-wrap': instance.$attrs['search-filter'] },

      // Font
      'leading-none',
      'text-regular',

      // Spacing
      'm-0 px-3 py-2',
      'first:mt-0 mt-[2px]',

      // Shape
      'border-0 rounded',

      // Colors
      {
        'text-surface-700': !context.focused && !context.selected,
        'bg-blue-50': context.focused && !context.selected,
        'text-surface-700': context.focused && !context.selected,
        'bg-blue-100': context.selected,
        'text-blue-800': context.selected,
      },

      // States
      { 'hover:bg-blue-50': !context.focused && !context.selected },
      { 'hover:bg-blue-200': context.selected },
      {
        'hover:text-blue-800 hover:bg-blue-50': context.focused && !context.selected,
      },

      // Transition
      'transition-shadow duration-200',

      // Misc
      'cursor-pointer overflow-hidden whitespace-nowrap',
    ],
    'data-testId': `${props.option}-select-option`,
  }),
  optionGroup: {
    class: [
      'font-semibold',
      'text-xs',

      // Spacing
      'm-0 py-2 px-3',

      // Colors
      'text-surface-400',

      // Misc
      'cursor-auto',
    ],
  },
  optionCheckIcon: 'relative -ms-1.5 me-1.5 text-blue-600 w-4 h-4',
  optionBlankIcon: 'w-4 h-4',
  emptyMessage: {
    class: [
      // Font
      'leading-none',
      'text-xs',

      // Spacing
      'py-2 px-3',

      // Color
      'text-surface-800',
      'bg-transparent',
    ],
  },
  header: {
    class: [
      // Spacing
      'pt-2 px-2 pb-0',
      'm-0',

      //Shape
      'border-b-0',
      'rounded-tl-md',
      'rounded-tr-md',

      // Color
      'text-surface-700',
      'bg-white',
      'border-surface-300',
    ],
  },
  clearIcon: {
    class: [
      // Color
      'text-blue-800 bg-blue-50',

      // Position
      'absolute',
      'top-1/2',
      'right-10',

      // Spacing
      '-mt-[6px]',

      // Size
      'w-4 h-3',
    ],
  },
  loadingIcon: {
    class: 'text-surface-400 animate-spin',
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass: 'transition-[transform,opacity] duration-120 ease-out',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0',
  },
};
